import styled, { css } from 'styled-components'
import zLayers from 'utils/styling/zLayers'

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${zLayers.modal};
  width: 100%;
  height: 100%;
  /* 
   * Background is transparent here because the proof tint is applied 
   * at the parent Page component level. This prevents the proof background from 
   * bleeding into clipped areas that will be cut away in production, ensuring 
   * only the actual printable content area shows the proof indication.
   * the background would sometimes bleed into clipped areas when added here
   */
  background: transparent;
  pointer-events: none;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
`

export const ProofText = styled.div`
  position: absolute;
  transform: rotate(-45deg);
  color: white;
  font-size: 2rem;
  user-select: none;
  pointer-events: none;
  white-space: nowrap;
  opacity: 0.1;
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ index }) => {
    const row = Math.floor(index / 3)
    const col = index % 3
    const top = row * 20 - 60
    const left = col * 20 - 20
    return css`
      top: ${top}%;
      left: ${left}%;
    `
  }}
`
